import { render, staticRenderFns } from "./BaseNav.vue?vue&type=template&id=fa0f8ad4&scoped=true"
import script from "./BaseNav.vue?vue&type=script&lang=js"
export * from "./BaseNav.vue?vue&type=script&lang=js"
import style0 from "./BaseNav.vue?vue&type=style&index=0&id=fa0f8ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0f8ad4",
  null
  
)

export default component.exports